import { FormatDate } from '@AMIEWEB/Notification/Tasks/Common/FormatData';
import { getHelperText, isValidDate } from '@AMIEWEB/Order/OrderCreationForm/RateCard/helper';
import { DateRangePicker } from 'app/ComponentLibrary/DateRangeNew';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useSelector } from 'react-redux';
import {
  selectCurrentModDetails,
  selectIsEditExistingMod,
  selectIsEditMod,
} from 'store/redux-store/placement-mods/selectors';
import { makeStyles } from 'tss-react/mui';
import moment from 'moment';
import { ApprovalStatus } from 'app/models/Placement/PlacementMods';

const effectiveDateStyle = makeStyles<{ expanded: boolean; noOptions: boolean }>()(
  (theme, { expanded, noOptions }) => ({
    effectiveDate: {
      marginLeft: '-2px',
    },
    label: {
      fontSize: '13px',
      marginTop: '2px',
    },
  }),
);

export const EffectiveDateSection = dialogProps => {
  const {
    expanded,
    selectedButton,
    setSelectedButtons,
    noOptions,
    effectiveDateError,
    setEffectiveDateError,
    setAlteredEffectiveDate,
    selectedRowDetails,
  } = dialogProps;
  const { t } = useTranslation();
  const { classes } = effectiveDateStyle({ expanded, noOptions });
  const isEditExistingMod = useSelector(selectIsEditExistingMod);
  const isModEdit = useSelector(selectIsEditMod);

  const selectedModsDetails = useSelector(selectCurrentModDetails);
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });

  const isDateModGreaterBooking = () => {
    const modName = selectedRowDetails?.type?.replaceAll(/['/.\s]/g, '');
    return (modName === 'StartDate' || modName === 'EndDate') && selectedModsDetails?.isBookingApprovedOrGreater;
  };

  const getReadOnlyStatus = () => {
    const modName = selectedRowDetails?.type?.replaceAll(/['/.\s]/g, '');

    if (!isModEdit && !isEditExistingMod) {
      return true;
    } else if (modName === 'Timeoff') {
      return true;
    } else if (modName === 'Insurance') {
      return true;
    } else if (modName === 'EMILMO') {
      return true;
    } else if (!isEditExistingMod && modName === 'Bonus') {
      return true;
    } else if (!isEditExistingMod && !isDateModGreaterBooking()) {
      return false;
    } else {
      if (
        (modName === 'StartDate' || modName === 'EndDate') &&
        selectedModsDetails?.isBookingApprovedOrGreater === false &&
        (selectedModsDetails?.approvalStatusId === ApprovalStatus.Pending ||
          selectedModsDetails?.approvalStatusId === ApprovalStatus.RecruiterApproved)
      ) {
        return false;
      }
      if (isDateModGreaterBooking()) {
        return true;
      }

      if (
        selectedModsDetails?.isBookingApprovedOrGreater &&
        (selectedModsDetails?.approvalStatusId === ApprovalStatus.Pending ||
          selectedModsDetails?.approvalStatusId === ApprovalStatus.RecruiterApproved)
      ) {
        if (modName === 'Bonus') {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }
  };

  useEffect(() => {
    const modName = selectedRowDetails?.type?.replaceAll(/['/.\s]/g, '');
    if (isEditExistingMod && getReadOnlyStatus() && modName !== 'Insurance') {
      if (
        selectedButton?.acceptedStatus &&
        selectedButton?.acceptedStatus !== selectedModsDetails?.acceptanceStatusId
      ) {
        setSelectedButtons({ ...selectedButton, effectiveDate: FormatDate(new Date()) });
      }

      if (selectedButton?.approvedStatus && selectedButton?.approvedStatus !== selectedModsDetails?.approvalStatusId) {
        setSelectedButtons({ ...selectedButton, effectiveDate: FormatDate(new Date()) });
      }
    }
  }, [selectedButton?.acceptedStatus, selectedButton?.approvedStatus]);

  return (
    <div className={classes.effectiveDate}>
      <DateRangePicker
        isDisabled={selectedButton?.isDelete || selectedButton?.isVoid || isSaveModApiCalling}
        onChange={d => {
          setSelectedButtons({
            ...selectedButton,
            effectiveDate: d.endDate ? moment(d.endDate)?.format('YYYY-MM-DDTHH:mm:ss') : null,
          });
          d.endDate
            ? (setEffectiveDateError({ status: false, helperText: '' }), setAlteredEffectiveDate(true))
            : setEffectiveDateError({ status: true, helperText: 'Required' });
        }}
        value={selectedButton?.effectiveDate}
        definedRanges={[]}
        actionBar={false}
        single={true}
        variant="outlined"
        labelClass={classes.label}
        secondaryLabel={t('placement.placementMods.effectiveDate')}
        clickAway={true}
        keepClickAwayVal={true}
        maxWidth={300}
        fullWidth
        readOnly={getReadOnlyStatus()}
        quickSelect={false}
        trailingIconShow={true}
        initialDateRange={{
          startDate: selectedButton?.effectiveDate,
          endDate: selectedButton?.effectiveDate,
        }}
        onBlurText={value => {
          setEffectiveDateError({
            status: !isValidDate(value),
            helperText: !isValidDate(value) ? getHelperText(value) : '',
          });
        }}
        error={effectiveDateError.status}
        helperText={effectiveDateError.helperText}
      />
    </div>
  );
};
